import ClickTracker from '@/components/Common/ClickTracker';
import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import styles from './index.module.scss';

const CardEventBanners = (): JSX.Element => {
  const store = useContext(NolPromotionStoreCtx);

  return (
    <div className={styles.bannerContainer}>
      <div>
        <div className={styles.bannerTitle}>NOL에서 NOL 혜택 받고 싶다면?</div>
        <ImpressionDivWrapper
          logData={{
            object: 'memberJoinBtn',

            objectContainer: '계산적으로 놀자 NOL 카드',
            motherPageVersion: store.version,
            motherPageSectionType: '',
            motherPageSectionName: 'NOL 카드 혜택 알림 받기',
          }}
        >
          <ClickTracker
            pageName={store.pageName}
            logData={{
              object: 'memberJoinBtn',
              objectType: 'Btn',
              objectContainer: '계산적으로 놀자 NOL 카드',
              motherPageVersion: store.version,
              motherPageSectionType: '',
              motherPageSectionName: 'NOL 카드 혜택 알림 받기',
              motherPageSectionNameSubTitle: '',
              deepLinkUri: 'yanoljamotel://etc/setting/agree',
            }}
          >
            <div className={styles.bannerImageContainer} onClick={() => store.agreeToMarketingTerms()}>
              <div className={styles.banner2} />
            </div>
          </ClickTracker>
        </ImpressionDivWrapper>
      </div>
    </div>
  );
};

export default observer(CardEventBanners);
